import styled from 'styled-components';
import { FontSize } from '../../assets/font';
import { 
    Typography,
    Grid,
    Link,
    Button,
    Card,
    Divider,
    LinearProgress
 } from '@mui/material';
import Color from '../../assets/colors';

// Typography
export const Title = styled(Typography)`
    && {
        font-size: ${FontSize.header4};
        color: ${Color.black};
    }
`;

export const CardTitle = styled(Typography)`
    && {
        font-size: ${FontSize.subheading};
        color: ${Color.white};
        font-weight: 600;
    }
`;

export const CardSubtitle = styled(Typography)`
    && {
        font-size: ${FontSize.body};
        color: ${Color.white};
        margin: 8px 0 0 0;
        width: 100%;
    }
`;

export const ProgressLabel = styled(Typography)`
    && {
        font-size: ${FontSize.body};
        font-weight: 400;
        color: ${Color.white};
        margin: 0 5px;
    }
`;

export const Date = styled(Typography)`
    && {
        font-size: ${FontSize.header4};
        font-weight: 400;
        width: 100%;
    }
`;

export const StatusText = styled(Typography)`
    && {
        font-size: ${FontSize.body};
        color: ${(props) => props.status == "Confirmed" ? Color.white : Color.black};
        font-weight: 500;
        text-align: center;
    }`

// Grid
export const MyMeetingsWidget = styled(Grid)`
    && {
        width: 45%;
        padding: 30px 35px;
        border: 1px solid ${Color.grey100};
        border-radius: 10px;
        margin: 40px;
    }
`;

export const DateSessions = styled(Grid)`
    && {
        padding: 0 5px;
    }
`;

export const ButtonWrapper = styled(Grid)`
    && {
        margin: 5px 2px;
        width: 100%;
    }
`;

export const ProgressBarWrapper = styled(Grid)`
    && {
        display: flex;
        align-items: center;
    }
`;

export const StatusWrapper = styled(Grid)`
    && {
        background-color: ${(props) => props.status == "Confirmed" ? Color.green100 : Color.white};
        border-radius: 10px;
        padding: 5px 10px;
        width: 100%;
    }
`;

 // Card
 export const CardStyled = styled(Card)`
    && {
        width: 100%;
        padding: 10px 25px;
        background-color: ${Color.sapphire100};
        margin: 12px 0;
    }
`;

// LinearProgress
export const LinearProgressStyled = styled(LinearProgress)`
    && {
        height: 14px;
        background-colour: ${Color.green100};
        margin-right: 10px; 
    }
`;

// Meeting List
export const MyMeetingList = styled(Grid)`
    && {
        width: 90%;
        padding: 20px 25px;
        border-radius: 10px;
        margin: 30px 40px;
    }
`;